import { render } from "./ViewProject.vue?vue&type=template&id=162a1011&scoped=true"
import script from "./ViewProject.vue?vue&type=script&lang=js"
export * from "./ViewProject.vue?vue&type=script&lang=js"

import "./ViewProject.vue?vue&type=style&index=0&id=162a1011&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-162a1011"]])

export default __exports__